import "./Header.css"
export default function Header({ onToggleSidebar, onOpenRoleModal }) {
    return (
        <header className="header">
            <div className="header-left">
                <button className="hamburger" onClick={onToggleSidebar}>
                    ☰
                </button>
                <h3>Admin</h3>
            </div>


        </header>
    );
}
